/*
  Composant « Souvent acheté avec » — fiche produit et panier.

  Defini comme custom element, et non comme script inline : quand le tiroir du
  panier se redessine, son contenu est reinjecte en HTML et les scripts inlines
  ne rejouent pas. Un custom element, lui, est mis a niveau automatiquement.
*/
(function () {
  if (customElements.get('mh-bonde')) return;

  // Couleur du robinet -> finition de la bonde. L'ordre compte : « or rose »
  // doit passer avant « or », « or » avant « noir » pour les bicolores.
  var REGLES = [
    [/or\s*rose\s*bross|rose\s*gold\s*bross/, 'or rose brosse'],
    [/or\s*rose|rose\s*gold/, 'or rose'],
    [/bronze|antique|vieilli/, 'or rose brosse'],
    [/chrome|argent|gris|inox|nickel|silver/, 'chrome poli'],
    [/\bor\b|dore|gold|laiton|brass/, 'or poli'],
    [/noir|black/, 'noir mat'],
    [/blanc|creme|white/, 'chrome poli']
  ];

  function sansAccent(valeur) {
    return (valeur || '')
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '');
  }

  function finitionPour(texte, defaut) {
    var t = sansAccent(texte);
    for (var i = 0; i < REGLES.length; i++) {
      if (REGLES[i][0].test(t)) return REGLES[i][1];
    }
    return sansAccent(defaut);
  }

  function sectionsAMettreAJour() {
    var noms = [];
    document.querySelectorAll('[id^="shopify-section-"]').forEach(function (el) {
      var nom = el.id.slice('shopify-section-'.length);
      if (nom.indexOf('cart-drawer') !== -1 || nom.indexOf('header') !== -1) noms.push(nom);
    });
    return noms.join(',');
  }

  class MhBonde extends HTMLElement {
    connectedCallback() {
      if (this.dataset.pret) return;

      var source = this.querySelector('[data-mhb-data]');
      if (!source) return;

      try {
        this.donnees = JSON.parse(source.textContent);
      } catch (e) {
        return;
      }

      this.dataset.pret = '1';

      this.img = this.querySelector('[data-mhb-img]');
      this.finitionTexte = this.querySelector('[data-mhb-finition]');
      this.prix = this.querySelector('[data-mhb-prix]');
      this.etat = this.querySelector('[data-mhb-etat]');
      this.bouton = this.querySelector('[data-mhb-add]');
      this.liens = this.querySelectorAll('[data-mhb-link]');

      this.finition = sansAccent(this.donnees.finition);

      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-mhb-axe2]')) this.rendre();
      });

      if (this.bouton) {
        this.bouton.addEventListener('click', () => this.ajouter());
      }

      // Sur la fiche produit, la finition suit la variante choisie.
      if (this.donnees.mode === 'fiche') {
        this.suivreVariante();
      }

      this.rendre();
    }

    suivreVariante() {
      var lire = (e) => {
        var r = e && e.detail && e.detail.resource;
        if (!r) return;
        var texte = r.title || '';
        if (r.options && r.options.join) texte = r.options.join(' ') + ' ' + texte;
        this.finition = finitionPour(texte, this.donnees.finition);
        this.rendre();
      };

      document.addEventListener('variant:updated', lire);
      document.addEventListener('variant:selected', () => {
        setTimeout(() => this.lireVarianteDeLaPage(), 60);
      });
      this.lireVarianteDeLaPage();
    }

    lireVarianteDeLaPage() {
      var picker = document.querySelector('variant-picker');
      if (!picker) return;
      var valeurs = Array.prototype.map.call(
        picker.querySelectorAll('select option[selected], fieldset input:checked'),
        function (el) {
          var label = el.closest('label');
          return (label ? label.textContent : el.value) || '';
        }
      ).join(' ');
      if (valeurs.trim()) {
        this.finition = finitionPour(valeurs, this.donnees.finition);
        this.rendre();
      }
    }

    axe2Choisi() {
      var coche = this.querySelector('[data-mhb-axe2]:checked');
      return coche ? coche.value : null;
    }

    varianteCourante() {
      var finition = this.finition;
      var candidats = this.donnees.variantes.filter(function (v) {
        return sansAccent(v.o1) === finition;
      });
      if (!candidats.length) candidats = this.donnees.variantes.slice();

      var axe2 = this.axe2Choisi();
      if (axe2) {
        var exact = candidats.filter(function (v) { return v.o2 === axe2; });
        if (exact.length) return exact[0];
      }
      return candidats[0];
    }

    rendre() {
      var v = this.varianteCourante();
      if (!v) return;

      this.dataset.variante = v.id;

      if (this.img && v.img) {
        this.img.src = v.img;
        if (v.alt) this.img.alt = v.alt;
      }
      if (this.finitionTexte) this.finitionTexte.textContent = v.o1 || '';
      if (this.prix) this.prix.textContent = v.prix;
      if (this.bouton) {
        this.bouton.disabled = !v.dispo;
        this.bouton.querySelector('[data-mhb-libelle]').textContent =
          v.dispo ? this.donnees.texteBouton : this.donnees.texteRupture;
      }
      this.liens.forEach(function (a) { a.href = v.url; });
    }

    ajouter() {
      var id = this.dataset.variante;
      if (!id) return;

      this.bouton.disabled = true;
      this.classList.add('is-chargement');
      if (this.etat) this.etat.hidden = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(id), quantity: 1 }],
          sections: sectionsAMettreAJour()
        })
      })
        .then(function (r) { return r.json(); })
        .then((ajout) => {
          if (ajout && ajout.status) throw new Error(ajout.description || 'refus');

          // Sur la page panier, un rechargement remet aussi a jour le total et
          // les paliers de remise. Depuis le tiroir ouvert sur une autre page,
          // on se contente de redessiner le tiroir.
          if (/\/cart(\/|$)/.test(window.location.pathname)) {
            window.location.reload();
            return null;
          }

          return fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (panier) {
              document.dispatchEvent(new CustomEvent('cart:updated', {
                bubbles: true,
                detail: {
                  resource: panier,
                  data: {
                    sections: ajout.sections,
                    itemCount: panier.item_count,
                    source: 'mh-bonde'
                  }
                }
              }));

              var tiroir = document.querySelector('cart-drawer');
              if (tiroir && typeof tiroir.open === 'function') tiroir.open();
            });
        })
        .then(() => {
          this.classList.remove('is-chargement');
          if (this.bouton) this.bouton.disabled = false;
        })
        .catch(() => {
          this.classList.remove('is-chargement');
          if (this.bouton) this.bouton.disabled = false;
          if (this.etat) {
            this.etat.textContent = this.donnees.texteErreur;
            this.etat.hidden = false;
          }
        });
    }
  }

  customElements.define('mh-bonde', MhBonde);
})();
